import store from "@/state/store";
import { getModuleAccess, showAccessRestrictedModal } from './helper.js'

export default [
  {
    path: "/",
    name: "Home",
    redirect: "/dashboard",
    meta: { authRequired: true },
    component: () => import("@/views/layouts/layout"),
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        // component: () => import('@/views/pages/dashboards/sales/index')
        component: () => import('@/views/pages/_version_2_/dashboard/index.vue'),
      },
      {
        path: "dashboard/eload-dashboard",
        name: "E-Load Dashboard",
        // component: () => import('@/views/pages/dashboards/sales/index')
        component: () => import('@/views/pages/_version_2_/dashboard/eload_index.vue'),
      },
      {
        path: "reports/puhunan-ctr",
        name: "Peddlr Puhunan CTR",
        component: () => import('@/views/pages/_version_2_/puhunan/campaign/index.vue'),
      },
      {
        path: "reports/puhunan-offers",
        name: "Puhunan Offers",
        component: () => import('@/views/pages/_version_2_/puhunan/offers/index.vue'),
      },
      {
        path: "reports/puhunan-disbursed",
        name: "Puhunan Disbursed",
        component: () => import('@/views/pages/_version_2_/puhunan/loans/index.vue'),
      },
      {
        path: "dashboard/kankolek",
        name: "KanKolek Dashboard",
        // component: () => import("@/views/pages/dashboards/kankolek/kankolek"),
        component: () => import('@/views/pages/_version_2_/dashboard/kankolek_index.vue'),
        // beforeEnter: async (to, from, next) => {
        //   await getModuleAccess('Dashboard', 'Kankolek').then((access) => {
        //     if(access.create || access.read || access.update || access.delete) {
        //       next()
        //     } else {
        //       showAccessRestrictedModal();
        //       next(from.path)
        //     }
        //   })
        // }
      },
      {
        path: "digital-offer/load",
        name: "Digital Load",
        redirect: '/digital-offer/load/eload',
        component: () => import("@/views/pages/e-load/Index"),
        children: [
          // {
          //   path: "eload",
          //   name: "E-Load",
          //   component: () => import("@/views/pages/e-load/ELoad"),
          //   beforeEnter: async (to, from, next) => {
          //     await getModuleAccess('Products', 'eLoad', 'eLoad Promo').then((access) => {
          //       if(access.create || access.read || access.update || access.delete) {
          //         next();
          //       } else {
          //         showAccessRestrictedModal();
          //         next(from.path);
          //       }
          //     })
          //   }
          // },
          {
            path: "eload/scheduler",
            name: "E-Load Scheduler",
            component: () => import("@/views/pages/e-load/eload_promo/schedule"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eLoad', 'eLoad Promo').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next();
                } else {
                  showAccessRestrictedModal();
                  next(from.path);
                }
              })
            }
          },
          {
            path: "eload/scheduler/:id",
            name: "E-Load Scheduler Detail",
            props: true,
            component: () => import("@/views/pages/e-load/eload_promo/schedule"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eLoad', 'eLoad Promo').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next();
                } else {
                  showAccessRestrictedModal();
                  next(from.path);
                }
              })
            }
          },
          {
            path: "provider",
            name: "E-Load Provider",
            component: () => import("@/views/pages/e-load/EloadProvider"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eLoad', 'eLoad Provider').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next();
                } else {
                  showAccessRestrictedModal();
                  next(from.path);
                }
              })
            }
          },
          {
            path: "provider/form/:id",
            name: "E-Load Provider Form",
            component: () => import("@/views/pages/e-load/EloadProviderForm"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eLoad', 'eLoad Provider').then((access) => {
                if (access.create && to.params.id <= 0) {
                  next()
                } else if((access.read || access.update) && to.params.id > 0) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "promo",
            name: "Category Promo",
            component: () => import("@/views/pages/e-load/CategoryPromo"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eLoad', 'eLoad Category').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next();
                } else {
                  showAccessRestrictedModal();
                  next(from.path);
                }
              })
            }
          },
          {
            path: "topups",
            name: "E-Load Topups",
            component: () => import("@/views/pages/e-load/EloadTopups"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eLoad', 'eLoad Topups').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next();
                } else {
                  showAccessRestrictedModal();
                  next(from.path);
                }
              })
            }
          },
          {
            path: "topups/sku/:id",
            name: "E-Load sku",
            component: () => import("@/views/pages/e-load/EloadTopupsSKUForm"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eLoad', 'eLoad Topups').then((access) => {
                if (access.create && to.params.id <= 0) {
                  next()
                } else if(access.read || access.update) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "topups/sku/:id/action/:token",
            name: "E-Load sku token",
            component: () => import("@/views/pages/e-load/EloadTopupsSKUForm"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eLoad', 'eLoad Topups').then((access) => {
                if (access.create && to.params.id <= 0) {
                  next()
                } else if(access.read || access.update) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "topups/campaign/:campaignId/:mode",
            name: "E-Load Campaign",
            props: true,
            component: () => import("@/views/pages/e-load/ELoadCampaignForm"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eLoad', 'eLoad Topups').then((access) => {
                if (access.create && to.params.campaignId <= 0) {
                  next()
                } else if(access.read || access.update) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "topups/campaign/action/:token/:action",
            name: "E-Load Campaign Action",
            props: true,
            component: () => import("@/views/pages/e-load/EloadCampaignAction")
          },
          // {
          //   path: "networks",
          //   name: "E-Load Networks",
          //   component: () => import("@/views/pages/e-load/Networks"),
          //   beforeEnter: async (to, from, next) => {
          //     await getModuleAccess('Products', 'eLoad', 'eLoad Networks').then((access) => {
          //       if(access.create || access.read || access.update || access.delete) {
          //         next();
          //       } else {
          //         showAccessRestrictedModal();
          //         next(from.path);
          //       }
          //     })
          //   }
          // },
          {
            path: "network-group",
            name: "E-Load Network Group",
            component: () => import("@/views/pages/e-load/NetworkGroup"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eLoad', 'eLoad Network Group').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next();
                } else {
                  showAccessRestrictedModal();
                  next(from.path);
                }
              })
            }
          },
          {
            path: "banner",
            name: "E-Load Banner",
            component: () => import("@/views/pages/e-load/EloadBanner"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eLoad', 'eLoad Banner').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next();
                } else {
                  showAccessRestrictedModal();
                  next(from.path);
                }
              })
            }
          }
        ]
      },
      {
        path: "digital-offer/eload/banner/:id",
        name: "E-Load Banner Form",
        component: () => import("@/views/pages/e-load/EloadBannerForm.vue"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Products', 'eLoad', 'eLoad Banner').then((access) => {
            if (access.create && to.params.id <= 0){
              next()
            } else if(access.read || access.update) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      
      {
        path: "digital-offer/load/promo/:id",
        name: "E-Load Category Form",
        component: () => import("@/views/pages/e-load/CategoryPromoForm.vue"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Products', 'eLoad', 'eLoad Category').then((access) => {
            if (access.create && to.params.id <= 0){
              next()
            } else if(access.read || access.update) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      // {
      //   path: "digital-offer/load/network/:id",
      //   name: "E-Load Network Form",
      //   component: () => import("@/views/pages/e-load/NetworkForm.vue"),
      //   beforeEnter: async (to, from, next) => {
      //     await getModuleAccess('Products', 'eLoad', 'eLoad Networks').then((access) => {
      //       if (access.create && to.params.id <= 0){
      //         next()
      //       } else if(access.read || access.update) {
      //         next()
      //       } else {
      //         showAccessRestrictedModal();
      //         next(from.path)
      //       }
      //     })
      //   }
      // },
      {
        path: "digital-offer/load/network-group/:id",
        name: "E-Load Network Group Form",
        component: () => import("@/views/pages/e-load/NetworkGroupForm.vue"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Products', 'eLoad', 'eLoad Network Group').then((access) => {
            if (access.create && to.params.id <= 0){
              next()
            } else if(access.read || access.update) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "digital-offer/load/special-category",
        name: "E-Load Special Category",
        component: () => import("@/views/pages/e-load/EloadSpecialCategory.vue"),
        // beforeEnter: async (to, from, next) => {
        //   await getModuleAccess('Products', 'eLoad', 'eLoad Network Group').then((access) => {
        //     if (access.create && to.params.id <= 0){
        //       next()
        //     } else if(access.read || access.update) {
        //       next()
        //     } else {
        //       showAccessRestrictedModal();
        //       next(from.path)
        //     }
        //   })
        // }
      },
      {
        path: "digital-offer/load/special-category/:id",
        name: "E-Load Special Category Form",
        component: () => import("@/views/pages/e-load/EloadSpecialCategoryForm.vue"),
        // beforeEnter: async (to, from, next) => {
        //   await getModuleAccess('Products', 'eLoad', 'eLoad Network Group').then((access) => {
        //     if (access.create && to.params.id <= 0){
        //       next()
        //     } else if(access.read || access.update) {
        //       next()
        //     } else {
        //       showAccessRestrictedModal();
        //       next(from.path)
        //     }
        //   })
        // }
      },
      {
        path: "digital-offer/bills",
        name: "Bills Payment",
        component: () => import("@/views/pages/billsPayment/index"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Products', 'Bills Payment', 'Bills Payment').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "digital-offer/bills/biller/:id",
        name: "Bills Payment Form",
        component: () => import("@/views/pages/billsPayment/billsPaymentForm"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Products', 'Bills Payment', 'Bills Payment').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "digital-offer/bills/provider",
        name: "Bills Payment Provider",
        component: () => import("@/views/pages/billsPayment/billsPaymentProvider"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Products', 'Bills Payment', 'Bills Payment Provider').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "digital-offer/bills/provider/:providerId",
        name: "Bills Payment Provider Form",
        props: true,
        component: () => import("@/views/pages/billsPayment/billsPaymentProviderForm"),
        beforeEnter: async (to, from, next) => {
          console.log("Router Name: ", to.params.providerId);
          await getModuleAccess('Products', 'Bills Payment', 'Bills Payment Provider').then((access) => {
            if(access.read || access.update) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "digital-offer/bills/category",
        name: "Bills Payment Category",
        component: () => import("@/views/pages/billsPayment/billsPaymentCategory"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Products', 'Bills Payment', 'Bills Payment Category').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "digital-offer/bills/category/:categoryId",
        name: "Bills Payment Category Form",
        props: true,
        component: () => import("@/views/pages/billsPayment/billsPaymentCategoryForm"),
        beforeEnter: async (to, from, next) => {
          console.log("Router Name: ", to.params.categoryId);
          await getModuleAccess('Products', 'Bills Payment', 'Bills Payment Category').then((access) => {
            if(access.read || access.update) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "report/bills-payment-topups",
        name: "Bills Payment Topup",
        component: () => import("@/views/pages/billsPayment/topupBillsPayment"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Reports','Bills Payment Transaction Logs', 'Top-ups').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "report/bills-payment-topups/details/:id/:userId",
        name: "Bills Payment Topup Details",
        component: () => import("@/views/pages/billsPayment/topupBillsPaymentDetails"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Reports','Bills Payment Transaction Logs', 'Top-ups').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "report/bills-payment-sell",
        name: "Bills Payment Sell",
        component: () => import("@/views/pages/billsPayment/sellBillsPayment"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Reports','Bills Payment Transaction Logs', 'Sell Bills payment').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "report/bills-payment-sell/details/:id/:userId",
        name: "Bills Payment Sell Details",
        component: () => import("@/views/pages/billsPayment/sellBillsPaymentDetails"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Reports','Bills Payment Transaction Logs', 'Sell Bills payment').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "kantoads/audit",
        name: "Audit Space",
        component: () => import('@/views/pages/kanto-ads/audit.vue'),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Products', 'Kanto Ads', 'Audit').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "kantoads/cancellation",
        name: "Audit Cancellation",
        component: () => import('@/views/pages/kanto-ads/cancellationIndex'),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Products', 'Kanto Ads', 'Audit').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "kantoads/cancellation/form/:id",
        name: "Audit Cancellation Form",
        component: () => import('@/views/pages/kanto-ads/cancellationForm'),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Products', 'Kanto Ads', 'Audit').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      // Disabling this route just incase ref: https://peddlr.atlassian.net/browse/PEDDLR-3344
      // {
      //   path: "kantoads/audit/details/:id",
      //   name: "Audit Space Details",
      //   props: true,
      //   component: () => import("@/views/pages/kanto-ads/audit-details"),
      //   beforeEnter: async (to, from, next) => {
      //     await getModuleAccess('Products', 'Kanto Ads', 'Audit').then((access) => {
      //       if(access.create || access.read || access.update || access.delete) {
      //         next()
      //       } else {
      //         showAccessRestrictedModal();
      //         next(from.path)
      //       }
      //     })
      //   }
      // },
      {
        path: "digital-offer/ml",
        name: "ML Diamond",
        component: () => import("@/views/pages/MLDiamond/index"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Products', 'Mobile Legend Diamond').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "profit-sharing/eload",
        name: "Eload Sharing",
        component: () => import("@/views/pages/eLoadProfitSharing/index"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Settings', 'Profit Sharing').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "rewards/black-coins",
        name: "Blvck Coins",
        component: () => import("@/views/pages/blvckCoins/index"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Products', 'BLVCK Coins').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "rewards/black-coins/addreward/:id",
        name: "Blvck Coins Add Rewards",
        props: true,
        component: () => import("@/views/pages/blvckCoins/rewards"),
        beforeEnter: async (to, from, next) => {
          console.log("Router Name: ", to.params.businessName);
          await getModuleAccess('Products', 'BLVCK Coins').then((access) => {
            if(access.create && to.params.id <= 0 || access.read || access.update) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "rewards/prp/rewards",
        name: "Peddlr Points",
        component: () => import("@/views/pages/peddlrRewardPoints/index"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Utilities', 'PRP', 'PRP Rewards').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "rewards/prp/category",
        name: "PRP Category",
        component: () => import("@/views/pages/peddlrRewardPoints/prpCategory"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Utilities', 'PRP', 'PRP Category').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "rewards/prp/category/:id",
        name: "PRP Category Form",
        component: () => import("@/views/pages/peddlrRewardPoints/prpCategoryForm"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Utilities', 'PRP', 'PRP Category').then((access) => {
            if (access.create && to.params.id <= 0) {
              next()
            } else if (access.read || access.update) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "rewards/prp/items",
        name: "PRP Items",
        component: () => import("@/views/pages/peddlrRewardPoints/prpItems"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Utilities', 'PRP', 'PRP Items').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "rewards/prp/items/:id",
        name: "PRP Item Form",
        component: () => import("@/views/pages/peddlrRewardPoints/prpItemForm"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Utilities', 'PRP', 'PRP Items').then((access) => {
            if (access.create && to.params.id <= 0) {
              next()
            } else if (access.read || access.update) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "rewards-edit/prp/:peddlrTrackingId",
        name: "Peddlr Points Edit",
        component: () => import("@/views/pages/peddlrRewardPoints/prpDetails.vue"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Utilities', 'PRP', 'PRP Rewards').then((access) => {
            if(access.read || access.update) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "events",
        name: "Event List",
        component: () => import("@/views/pages/peddlrEvents/index"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Utilities', 'Events').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "raffle-promo",
        name: "Raffle Promo",
        component: () => import("@/views/pages/rafflePromo/index"),
        beforeEnter: async (to, from, next) => {
          next()
          // await getModuleAccess('Utilities', 'Events').then((access) => {
          //   if(access.create || access.read || access.update || access.delete) {
          //     next()
          //   } else {
          //     showAccessRestrictedModal();
          //     next(from.path)
          //   }
          // })
        }
      },
      {
        path: "careers/job-opening",
        name: "Job Opening",
        component: () => import("@/views/pages/careers/JobOpening"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Utilities', 'Careers', 'Job Opening').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "careers/job-opening/form/:id",
        name: "Add Job Opening",
        component: () => import("@/views/pages/careers/JobOpeningForm"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Utilities', 'Careers', 'Job Opening').then((access) => {
            if (access.create && to.params.id <= 0) {
              next()
            } else if (access.read || access.update) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "careers/job-opening/details/:id",
        name: "View Job Opening",
        component: () => import("@/views/pages/careers/JobOpeningDetails"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Utilities', 'Careers', 'Job Opening').then((access) => {
            if(access.read || access.update) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "careers/department-team",
        name: "Department Team",
        component: () => import("@/views/pages/careers/DepartmentTeam"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Utilities', 'Careers', 'Department Teams').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "events/item/:id",
        name: "Add Event",
        component: () => import("@/views/pages/peddlrEvents/EventForm.vue"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Utilities', 'Events').then((access) => {
            if(access.create && to.params.id <= 0) {
              next()
            } else if(access.read || access.update) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "events/details/:id",
        name: "Event Details",
        component: () => import("@/views/pages/peddlrEvents/EventDetails.vue"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Utilities', 'Events').then((access) => {
            if(access.read || access.update) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "product",
        name: "Product",
        redirect: '/product/template',
        component: () => import("@/views/pages/product-listing/Index"),
        children: [
          {
            path: "template",
            name: "Product Template",
            component: () => import("@/views/pages/product-listing/ProductTemplate"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Utilities', 'Product Template', 'Product Suggestion').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "template/import",
            name: "Product Template Mass Upload",
            component: () => import("@/views/pages/product-listing/ProductTemplateMassUpload"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Utilities', 'Product Template', 'Product Suggestion').then((access) => {
                if(access.create) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "template/form/:productId?",
            name: "Product Template Form",
            props: true,
            component: () => import("@/views/pages/product-listing/ProductTemplateForm"),
            beforeEnter: async (to, from, next) => {
              console.log('to.params.productId: ', to.params.productId)
              await getModuleAccess('Utilities', 'Product Template', 'Product Suggestion').then((access) => {
                if (access.create && to.params.productId == undefined){
                  next()
                } else if(access.read || access.update) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "category",
            name: "Business Category",
            component: () => import("@/views/pages/product-listing/BusinessCategory"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Utilities', 'Business Category').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "category/:action",
            name: "Add Business Category",
            component: () => import("@/views/pages/product-listing/BusinessCategoryManageItem"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Utilities', 'Business Category').then((access) => {
                if(access.create) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "category/:action/:id",
            name: "Edit Business Category",
            component: () => import("@/views/pages/product-listing/BusinessCategoryManageItem"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Utilities', 'Business Category').then((access) => {
                if(access.read || access.update) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "brand",
            name: "Product Brand",
            component: () => import("@/views/pages/product-listing/ProductBrand"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Utilities', 'Product Template', 'Product Brand').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "group",
            name: "Product Group",
            component: () => import("@/views/pages/product-listing/ProductGroup"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Utilities', 'Product Template', 'Product Category').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          }
        ]
      },
      {
        path: 'eseller',
        name: 'ESeller',
        redirect: '/eseller/brand',
        component: () => import('@/views/pages/e-seller/ESeller.vue'),
        children: [
          {
            path: "brand",
            name: "ESeller Brand",
            component: () => import("@/views/pages/e-seller/Brand.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eSupplies', 'Sellers').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "category",
            name: "ESeller Category",
            component: () => import("@/views/pages/e-seller/BusinessCategory.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eSupplies', 'Categories').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "category/:action",
            name: "ESeller Add Category",
            component: () => import("@/views/pages/e-seller/BusinessCategoryManageItem.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eSupplies', 'Categories').then((access) => {
                if(access.create) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            },
          },
          {
            path: "category/:action/:id",
            name: "ESeller Edit Category",
            component: () => import("@/views/pages/e-seller/BusinessCategoryManageItem.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eSupplies', 'Categories').then((access) => {
                if(access.read || access.update) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            },
          },
          {
            path: "product",
            name: "ESeller Product",
            component: () => import("@/views/pages/e-seller/Product.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eSupplies', 'Products').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "banner",
            name: "ESeller Banner",
            component: () => import("@/views/pages/e-seller/Banner.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eSupplies', 'Banners').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "banner/:action",
            name: "ESeller Add Banner",
            component: () => import("@/views/pages/e-seller/BannerManageItem.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eSupplies', 'Banners').then((access) => {
                if(access.create) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "banner/:action/:id",
            name: "ESeller Edit Banner",
            component: () => import("@/views/pages/e-seller/BannerManageItem.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eSupplies', 'Banners').then((access) => {
                if(access.read || access.update) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "brand-add/:id",
            name: "Add Seller Account Brand",
            component: () => import("@/views/pages/e-seller/BrandAddItem.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eSupplies', 'Sellers').then((access) => {
                if (access.create && to.params.id <= 0){
                  next()
                } else if(access.read || access.update) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "orders",
            name: "ESeller Orders",
            component: () => import("@/views/pages/e-seller/orders.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eSupplies', 'Orders').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
        ]
      },
      {
        path: 'eloadb2b',
        name: 'EloadB2B',
        redirect: '/eloadb2b/requests',
        component: () => import('@/views/pages/eloadB2B/Index.vue'),
        children: [
          {
            path: "requests",
            name: "Eload B2B Requests",
            component: () => import("@/views/pages/eloadB2B/Requests.vue"),
            // TODO: PEDDLR-5804 Add access checking
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eLoad B2B', 'Request').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "form/:id",
            name: "Eload B2B Request Form",
            props: true,  
            component: () => import("@/views/pages/eloadB2B/RequestForm.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eLoad B2B', 'Request').then((access) => {
                if(access.create) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "details/:refNo",
            name: "Eload B2B Request details",
            props: true,  
            component: () => import("@/views/pages/eloadB2B/details.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eLoad B2B', 'Request').then((access) => {
                if(access.read || access.update) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
        ]
      },
      {
        path: "customer",
        name: "Customer",
        redirect: '/customer/subscriber',
        component: () => import("@/views/pages/customer/Index"),
        children: [
          {
            path: "subscriber",
            name: "Subscriber",
            component: () => import("@/views/pages/subscriberInformation/index"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Merchant Management', 'Merchant').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "subscriber/:id",
            name: "Subscriber Detail",
            props: true,
            component: () => import("@/views/pages/subscriberDetails/profile"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Merchant Management', 'Merchant').then((access) => {
                if(access.read || access.update) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "profile-information/:tab/:bid",
            name: "Profile Information",
            props: true,
            component: () => import("@/views/pages/profileInformation/index"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Merchant Management', 'Merchant').then((access) => {
                if(access.read || access.update) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "profile-information/:tab/:bid/:wallet",
            name: "Profile Information Wallet",
            props: true,
            component: () => import("@/views/pages/profileInformation/indexWallet"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Merchant Management', 'Merchant').then((access) => {
                if(access.read || access.update) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            },
          },
          {
            path: "profile-information/Profile/:bid/peddlr-wallet/edit-limit",
            name: "Peddlr Wallet Limit",
            props: true,
            component: () => import("@/views/pages/profileInformation/wallet/peddlrWalletLimit"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Merchant Management', 'Merchant').then((access) => {
                if(access.read || access.update) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            },
          },
          {
            path: "profile-information/:tab/:bid/kyc/details",
            name: "Profile Information Kyc",
            props: true,
            component: () => import("@/views/pages/profileInformation/profileKycForm"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Merchant Management', 'Merchant').then((access) => {
                if(access.read || access.update) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "business",
            name: "Business",
            component: () => import("@/views/pages/businessInformation/index"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Merchant Management', 'Business Info').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next();
                } else {
                  showAccessRestrictedModal();
                  next(from.path);
                }
              })
            }
          },
          {
            path: "business/:id",
            name: "Business Detail",
            props: true,
            component: () => import("@/views/pages/businessDetails/business"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Merchant Management', 'Business Info').then((access) => {
                console.log('access: ',access)
                if(access.read || access.update) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
        ]
      },
      {
        path: "report",
        name: "Report",
        redirect: '/report/topup-transaction',
        component: () => import("@/views/pages/report/Index"),
        children: [
          {
            path: "topup-transaction",
            name: "Topup Transaction",
            component: () => import("@/views/pages/report/topup-transactions/TopupTransactions"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Reports', 'ELoad Transaction Logs', 'Top-ups').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "eload-transaction",
            name: "Eload Transaction",
            component: () => import("@/views/pages/report/eload-transactions/EloadTransactions.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Reports', 'ELoad Transaction Logs', 'Sell-eload').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "blvck-topup-transaction",
            name: "BLVCK topup Transaction",
            component: () => import("@/views/pages/report/topup-transactions/BlvckTopupTransactions"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Reports', 'BLVCK Transaction Logs', 'Top-ups').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "eload-rewards",
            name: "Eload Rewards",
            component: () => import("@/views/pages/report/eload-transactions/EloadRewards2"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Reports', 'ELoad Transaction Logs', 'Rewards').then((access) => {
                if(access.create || access.read || access.update || access.delete || access.requester || access.approver) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "eload-add-rewards/:id/:action",
            name: "Eload Add Rewards",
            component: () => import("@/views/pages/report/eload-transactions/EloadAddRewards2"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Reports', 'ELoad Transaction Logs', 'Rewards').then((access) => {
                if(access.create || access.requester) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "eload-view-rewards/:id",
            name: "Eload View Rewards",
            component: () => import("@/views/pages/report/eload-transactions/EloadViewRewards2"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Reports', 'ELoad Transaction Logs', 'Rewards').then((access) => {
                if(access.read || access.update) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "topup-transaction/:id",
            name: "Topup Transaction Details",
            component: () => import("@/views/pages/report/topup-transactions/TopupTransactionDetails.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Reports', 'ELoad Transaction Logs', 'Top-ups').then((access) => {
                if(access.read || access.update) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "eload-transaction/:id",
            name: "Eload Transaction Details",
            component: () => import("@/views/pages/report/eload-transactions/EloadTransactionDetails.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Reports', 'ELoad Transaction Logs', 'Sell-eload').then((access) => {
                if(access.read) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          }
        ]
      },
      {
        path: "management/roles",
        name: "Roles",
        component: () => import("@/views/pages/roles/index"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Settings', 'User Management', 'Roles').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "management/roles/:action",
        name: "Add Role",
        component: () => import("@/views/pages/roles/ManageRole.vue"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Settings', 'User Management', 'Roles').then((access) => {
            if(access.create && to.params.action == 'add') {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "management/roles/:action/:id",
        name: "Update Role",
        component: () => import("@/views/pages/roles/ManageRole.vue"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Settings', 'User Management', 'Roles').then((access) => {
            if(access.read || access.update) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "management/user",
        name: "Users",
        component: () => import("@/views/pages/users/index"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Settings', 'User Management', 'Users').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "management/user/:id",
        name: "Manage User",
        component: () => import("@/views/pages/users/ManageUser"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Settings', 'User Management', 'Users').then((access) => {
            if(access.read || access.update) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "Roulette",
        name: "Roulette",
        redirect: '/roulette/roulette-main',
        component: () => import("@/views/pages/roulette/Index"),
        children: [
          {
            path: "roulette-main",
            name: "Roulette Main",
            component: () => import("@/views/pages/roulette/Main.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Utilities', 'Roulette', 'Roulette Main').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "roulette-item",
            name: "Roulette Item",
            component: () => import("@/views/pages/roulette/Item.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Utilities', 'Roulette', 'Roulette Item').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "roulette-add",
            name: "Roulette Add",
            component: () => import("@/views/pages/roulette/AddEditItem.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Utilities', 'Roulette', 'Roulette Item').then((access) => {
                if(access.create) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "roulette-edit/:id",
            name: "Roulette Edit",
            component: () => import("@/views/pages/roulette/AddEditItem.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Utilities', 'Roulette', 'Roulette Item').then((access) => {
                if(access.read || access.update) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "roulette-main-add",
            name: "Roulette Main Add",
            component: () => import("@/views/pages/roulette/AddEditMain.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Utilities', 'Roulette', 'Roulette Main').then((access) => {
                if(access.read || access.create) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "roulette-main-edit/:id",
            name: "Roulette Main Edit",
            component: () => import("@/views/pages/roulette/AddEditMain.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Utilities', 'Roulette', 'Roulette Main').then((access) => {
                if(access.read || access.update) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "roulette-reward",
            name: "Roulette Reward",
            component: () => import("@/views/pages/roulette/Reward.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Utilities', 'Roulette', 'Roulette Reward').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: "roulette-reward-edit/:peddlrTrackingId",
            name: "Roulette Reward Edit",
            component: () => import("@/views/pages/roulette/RewardDetails.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Utilities', 'Roulette', 'Roulette Reward').then((access) => {
                if(access.read || access.update) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
        ]
      },
      {
        path: "agent",
        name: "Agent",
        component: () => import("@/views/pages/agent/AgentForm.vue")
      },
      {
        path: "mode-of-payment",
        name: "ModeOfPayment",
        component: () => import("@/views/pages/mode-of-payment/ModeOfPayment.vue"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Settings', 'Modes of Payment').then((access) => {
            if(access.create || access.update || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "mode-of-payment/main/:mopId/:mode",
        name: "MainModeForm",
        props: true,
        component: () => import("@/views/pages/mode-of-payment/MainModeForm.vue"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Settings', 'Modes of Payment').then((access) => {
            if(access.create && to.params.mode == 'add') {
              next()
            } else if ((access.read || access.update) && to.params.mode == 'edit') {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "mode-of-payment/module/:methodId/:mode",
        name: "ModuleModeForm",
        props: true,
        component: () => import("@/views/pages/mode-of-payment/ModuleModeForm.vue"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Settings', 'Modes of Payment').then((access) => {
            if(access.create && to.params.mode == 'add') {
              next()
            } else if ((access.read || access.update) && to.params.mode == 'edit') {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "kanto-ads/topup",
        name: "KantoAdsTopup",
        props: true,
        component: () => import("@/views/pages/kanto-ads/topup.vue"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Products', 'Kanto Ads', 'Top-up Bank Transfer').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "kanto-ads/topup/update/:id",
        name: "KantoAdsTopupDetails",
        props: true,
        component: () => import("@/views/pages/kanto-ads/topupDetails.vue"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Products', 'Kanto Ads', 'Top-up Bank Transfer').then((access) => {
            if(access.read || access.update) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "kanto-ads/cashout",
        name: "KantoAdsCashout",
        props: true,
        component: () => import("@/views/pages/kanto-ads/cashout.vue"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Products', 'Kanto Ads', 'Wallet Cashout').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "kanto-ads/cashout/:id",
        name: "KantoAdsCashoutDetails",
        props: true,
        component: () => import("@/views/pages/kanto-ads/cashoutDetails.vue"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Products', 'Kanto Ads', 'Wallet Cashout').then((access) => {
            if(access.read || access.update) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "maintenance-mode",
        name: "Maintenance Mode",
        props: true,
        component: () => import("@/views/pages/maintenance/index.vue"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Settings', 'Maintenance Mode').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "kk-web-invitation",
        name: "KK Web Account Invitation",
        props: true,
        component: () => import("@/views/pages/kk-web/invitationView.vue"),
        // beforeEnter: async (to, from, next) => {
        //   await getModuleAccess('Settings', 'KK Web Account Invitation').then((access) => {
        //     if(access.create || access.read || access.update || access.delete) {
        //       next()
        //     } else {
        //       showAccessRestrictedModal();
        //       next(from.path)
        //     }
        //   })
        // }
      },
      {
        path: "wallet-freezing",
        name: "Wallet Freezing",
        component: () => import("@/views/pages/_version_2_/peddlr-lite/wallet-freezing/index.vue"),
      },
      {
        path: "transaction-monitoring",
        name: "Transaction Monitoring",
        component: () => import("@/views/pages/kankolek/transaction-monitoring/index.vue"),
      },
      // Peddlr Lite (PEDDLR-7104) merchant listing/details. Separate from the Peddlr App merchant
      // routes (Subscriber / Profile Information / ...). These pages read peddlr_v6 via /v6/lite.
      {
        path: "peddlr-lite/merchant",
        name: "Merchant Lite",
        component: () => import("@/views/pages/_version_2_/peddlr-lite/merchant/subscriberInformation/index.vue"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Merchant Management', 'Merchant').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "peddlr-lite/merchant/profile-information/:tab/:bid",
        name: "Lite Profile Information",
        props: true,
        component: () => import("@/views/pages/_version_2_/peddlr-lite/merchant/profileInformation/index.vue"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Merchant Management', 'Merchant').then((access) => {
            if(access.read || access.update) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "peddlr-lite/merchant/profile-information/:tab/:bid/kyc/details",
        name: "Lite Profile Information Kyc",
        props: true,
        component: () => import("@/views/pages/_version_2_/peddlr-lite/merchant/profileInformation/profileKycForm.vue"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Merchant Management', 'Merchant').then((access) => {
            if(access.read || access.update) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "peddlr-lite/merchant/profile-information/:tab/:bid/:wallet",
        name: "Lite Profile Information Wallet",
        props: true,
        component: () => import("@/views/pages/_version_2_/peddlr-lite/merchant/profileInformation/indexWallet.vue"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Merchant Management', 'Merchant').then((access) => {
            if(access.read || access.update) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "kankolek-deposit",
        name: "Kankolek Deposit",
        props: true,
        component: () => import("@/views/pages/kankolek/deposit.vue"),
        // beforeEnter: async (to, from, next) => {
        //   await getModuleAccess('Settings', 'Kankolek', 'Deposit').then((access) => {
        //     if(access.create || access.read || access.update || access.delete) {
        //       next()
        //     } else {
        //       showAccessRestrictedModal();
        //       next(from.path)
        //     }
        //   })
        // }
      },
      {
        path: "cif-mobile-number",
        name: "CIF Mobile Number",
        props: true,
        component: () => import("@/views/pages/kankolek/cif.vue"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Settings', 'CIF Mobile Number').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      {
        path: "kankolek/adjustment",
        name: "Kankolek Adjustment Index",
        redirect: '/kankolek/adjustment/dashboard',
        component: () => import("@/views/pages/kankolek/adjustment/index.vue"),
        children: [
          {
            path: "dashboard",
            name: "Adjustment Transaction Dashboard",
            props: true,  
            component: () => import("@/views/pages/kankolek/adjustment/dashboard.vue"),
            // beforeEnter: async (to, from, next) => {
            //   await getModuleAccess('Settings', 'Kankolek', 'Deposit').then((access) => {
            //     if(access.create || access.read || access.update || access.delete) {
            //       next()
            //     } else {
            //       showAccessRestrictedModal();
            //       next(from.path)
            //     }
            //   })
            // }
          },
          {
            path: "form/:id",
            name: "Adjustment Transaction Form",
            props: true,  
            component: () => import("@/views/pages/kankolek/adjustment/form.vue"),
            // beforeEnter: async (to, from, next) => {
            //   await getModuleAccess('Settings', 'Kankolek', 'Deposit').then((access) => {
            //     if(access.create || access.read || access.update || access.delete) {
            //       next()
            //     } else {
            //       showAccessRestrictedModal();
            //       next(from.path)
            //     }
            //   })
            // }
          },
          {
            path: "batch-upload",
            name: "Adjustment Transaction Batch Upload",
            props: true,  
            component: () => import("@/views/pages/kankolek/adjustment/batch-upload.vue"),
            // beforeEnter: async (to, from, next) => {
            //   await getModuleAccess('Settings', 'Kankolek', 'Deposit').then((access) => {
            //     if(access.create || access.read || access.update || access.delete) {
            //       next()
            //     } else {
            //       showAccessRestrictedModal();
            //       next(from.path)
            //     }
            //   })
            // }
          },
          {
            path: "action/:token/:action",
            name: "Adjustment Transaction Action",
            props: true,
            component: () => import("@/views/pages/kankolek/adjustment/action.vue")
          },
          {
            path: "bulk-action/:token/:s3_url/:action",
            name: "Adjustment Transaction Bulk Action",
            props: true,
            component: () => import("@/views/pages/kankolek/adjustment/bulk-action.vue")
          },
        ]
      },
      {
        path: "notification",
        name: "Notification Index",
        redirect: 'notification/dashboard',
        component: () => import("@/views/pages/notification/index.vue"),
        children: [
          {
            path: "dashboard",
            name: "Notification Dashboard",
            props: true,  
            component: () => import("@/views/pages/notification/dashboard.vue"),
            // beforeEnter: async (to, from, next) => {
            //   await getModuleAccess('Settings', 'Kankolek', 'Deposit').then((access) => {
            //     if(access.create || access.read || access.update || access.delete) {
            //       next()
            //     } else {
            //       showAccessRestrictedModal();
            //       next(from.path)
            //     }
            //   })
            // }
          },
          {
            path: "form/:id",
            name: "Notification Form",
            props: true,  
            component: () => import("@/views/pages/notification/form.vue"),
            // beforeEnter: async (to, from, next) => {
            //   await getModuleAccess('Settings', 'Kankolek', 'Deposit').then((access) => {
            //     if(access.create || access.read || access.update || access.delete) {
            //       next()
            //     } else {
            //       showAccessRestrictedModal();
            //       next(from.path)
            //     }
            //   })
            // }
          },
        ]
      },
      {
        path: '/dashboard/provider',
        name: 'Eload Provider',
        component: () => import('@/views/pages/dashboards/provider/provider.vue'),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess('Dashboard', 'Eload Proviver').then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              showAccessRestrictedModal();
              next(from.path)
            }
          })
        }
      },
      /* VERSION TWO */
      // SMS Blast Campaign
      {
        path: '/others/smsblast',
        name: 'SMS Blast Campaign',
        component: () => import('@/views/pages/_version_2_/others/sms_blast/dashboard.vue'),
      },
      {
        path: '/others/smsblast/campaign/:id',
        name: 'SMS Blast Campaign Add',
        component: () => import('@/views/pages/_version_2_/others/sms_blast/add_campaign.vue'),
        props: true,
      },
      {
        path: '/others/smsblast/campaign/view/:id',
        name: 'SMS Blast Campaign View',
        component: () => import('@/views/pages/_version_2_/others/sms_blast/view_campaign.vue'),
        props: true,
      },
      {
        path: '/core/eload',
        name: 'E-Load Core',
        redirect: '/core/eload',
        component: () => import('@/views/pages/_version_2_/eload-core/Index.vue'),
        children: [
           {
            path: 'sku/master',
            name: 'E-Load Core SKU Master',
            component: () => import('@/views/pages/_version_2_/eload-core/sku-master/index.vue'),
          },
          {
            path: 'sku/master/:id',
            props: true,
            name: 'E-Load Core SKU Master Form',
            component: () => import('@/views/pages/_version_2_/eload-core/sku-master/skuForm.vue'),
          },
          {
            path: 'sku/main',
            name: 'E-Load Core SKU',
            component: () => import('@/views/pages/_version_2_/eload-core/sku-main/index.vue'),
          },
          {
            path: 'sku/main/:id',
            props: true,
            name: 'E-Load Core SKU Form',
            component: () => import('@/views/pages/_version_2_/eload-core/sku-main/skuForm.vue'),
          },
          {
            path: 'provider',
            name: 'E-Load Core Provider',
            component: () => import('@/views/pages/_version_2_/eload-core/provider/index.vue'),
          },
          {
            path: 'provider/:id',
            props: true,
            name: 'E-Load Core Provider Form',
            component: () => import('@/views/pages/_version_2_/eload-core/provider/providerForm.vue'),
          },
          {
            path: 'network',
            name: 'E-Load Core Network',
            component: () => import('@/views/pages/_version_2_/eload-core/network/index.vue'),
          },
          {
            path: 'network/:id',
            props: true,
            name: 'E-Load Core Network Form',
            component: () => import('@/views/pages/_version_2_/eload-core/network/networkForm.vue'),
          },
          {
            path: 'maintenance',
            name: 'E-Load Core Maintenance',
            component: () => import('@/views/pages/_version_2_/eload-core/maintenance/index.vue'),
          },
          {
            path: 'maintenance/:id',
            props: true,
            name: 'E-Load Core Maintenance Form',
            component: () => import('@/views/pages/_version_2_/eload-core/maintenance/maintenanceForm.vue'),
          },
          {
            path: 'sku/test',
            name: 'E-Load SKU Test',
            component: () => import('@/views/pages/_version_2_/eload-core/sku-test/dashboard.vue'),
            props: true,
          },
          {
            path: 'sku/schedule',
            name: 'E-Load Core SKU Schedule',
            component: () => import('@/views/pages/_version_2_/eload-core/sku-schedule/index.vue'),
          },
          {
            path: 'sku/schedule/:id',
            props: true,
            name: 'E-Load Core SKU Schedule Form',
            component: () => import('@/views/pages/_version_2_/eload-core/sku-schedule/scheduleForm.vue'),
          },
        ]
      },
      
      {
        path: '/lite/eload',
        name: 'E-Load Lite',
        redirect: '/lite/eload',
        component: () => import('@/views/pages/_version_2_/eload-litev6/Index.vue'),
        children: [
           {
            path: 'sku/manager',
            name: 'E-Load Lite SKU Manager',
            component: () => import('@/views/pages/_version_2_/eload-litev6/sku/index.vue'),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eLoad', 'eLoad Promo').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next();
                } else {
                  showAccessRestrictedModal();
                  next(from.path);
                }
              })
            }
          },
          {
            path: "sku/manager/:id",
            name: "E-Load Lite SKU Form",
            component: () => import("@/views/pages/_version_2_/eload-litev6/sku/eloadForm.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eLoad', 'eLoad Promo').then((access) => {
                if (access.create && to.params.id <= 0){
                  next()
                } else if(access.read || access.update) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
          {
            path: 'sku/maintenance',
            name: 'Eload Maintenance',
            component: () => import("@/views/pages/_version_2_/eload-litev6/maintenance/index.vue"),
          },
          {
            path: "sku/maintenance/:id",
            name: "Eload Maintenance Form",
            props: true,  
            component: () => import("@/views/pages/_version_2_/eload-litev6/maintenance/maintenanceForm.vue"),
          },
          {
            path: "sku/category",
            name: "E-Load Lite Category Promo",
            component: () => import("@/views/pages/_version_2_/eload-litev6/category/index.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eLoad', 'eLoad Category').then((access) => {
                if(access.create || access.read || access.update || access.delete) {
                  next();
                } else {
                  showAccessRestrictedModal();
                  next(from.path);
                }
              })
            }
          },
          {
            path: "sku/category/:id",
            name: "E-Load Lite Category Form",
            component: () => import("@/views/pages/_version_2_/eload-litev6/category/categoryForm.vue"),
            beforeEnter: async (to, from, next) => {
              await getModuleAccess('Products', 'eLoad', 'eLoad Category').then((access) => {
                if (access.create && to.params.id <= 0){
                  next()
                } else if(access.read || access.update) {
                  next()
                } else {
                  showAccessRestrictedModal();
                  next(from.path)
                }
              })
            }
          },
        ]
      },
      {
        path: "gbits/account-creation",
        name: "GBITS Account Creation",
        props: true,
        component: () => import("@/views/pages/_version_2_/gbits/invitation/index.vue"),
      },
      {
        path: "gbits/topup-request",
        name: "GBITS Topup Request Approval",
        redirect: '/gbits/topup-request/requests',
        component: () => import("@/views/pages/_version_2_/gbits/topup-request/Index.vue"),
        children: [
          {
            path: "requests",
            name: "GBITS Topup Requests",
            component: () => import("@/views/pages/_version_2_/gbits/topup-request/Requests.vue"),
          },
          {
            path: "form/:id",
            name: "GBITS Topup Request Form",
            props: true,
            component: () => import("@/views/pages/_version_2_/gbits/topup-request/RequestForm.vue"),
          },
          {
            path: "details/:refNo",
            name: "GBITS Topup Request Details",
            props: true,
            component: () => import("@/views/pages/_version_2_/gbits/topup-request/details.vue"),
          },
          {
            path: "action",
            name: "GBITS Topup Request Action",
            component: () => import("@/views/pages/_version_2_/gbits/topup-request/action.vue"),
          },
        ]
      },
      {
        path: '#',
        name: 'Coming Soon',
        component: () => import('@/views/pages/_version_2_/coming-soon/index.vue'),
        props: true,
      },

      // {
      //   path: '/dashboard/test',
      //   name: 'Dashboard Test',
      //   component: () => import('@/views/pages/_version_2_/dashboard/index.vue'),
      // },
      

    ]
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/pages/account/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "Home" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },

  {
    path: "/register",
    name: "Register",
    component: () => import("../views/pages/account/register"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "Home" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  
  {
    path: "/error/404-basic",
    name: "error-404-basic",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/errors/404-basic"),
  },
  {
    path: "/error/404-cover",
    name: "error-404-cover",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/errors/404-cover"),
  },
  {
    path: "/error/500-basic",
    name: "error-500-basic",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/errors/500-basic"),
  },
  {
    path: "/error/500-cover",
    name: "error-500-cover",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/errors/500-cover"),
  },
  {
    path: "/raffle-promo/live-draw",
    name: "live draw",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/rafflePromo/liveDraw"),
    beforeEnter: async (to, from, next) => {
      next()
      // await getModuleAccess('Utilities', 'Events').then((access) => {
      //   if(access.create || access.read || access.update || access.delete) {
      //     next()
      //   } else {
      //     showAccessRestrictedModal();
      //     next(from.path)
      //   }
      // })
    }
  },
];
